import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {BaseComponent, CartPromoCode, CompoApiService, EventData} from 'compob2b-libs';
import {Observable} from 'rxjs';
import {map, takeUntil, tap} from 'rxjs/operators';
import {EventCartService} from '../services/event-cart.service';

@Component({
    selector: 'app-promo-code',
    templateUrl: './promo-code.component.html',
    styles: `
    :host {
      gap: 10px;
      display: flex;

    input {
      max-width: 100px !important;
    }
    }
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PromoCodeComponent extends BaseComponent implements OnInit {
  promoCodeControl: UntypedFormControl;

  constructor(
    private readonly apiService: CompoApiService,
    private readonly eventCartService: EventCartService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.promoCodeControl = new UntypedFormControl();

    this.pull().pipe(tap(response => this.handlePullResponse(response))).subscribe();
  }

  private handlePullResponse(response: CartPromoCode) {
    this.promoCodeControl.setValue(response !== null && response.promoCode !== null ? response.promoCode : '');
    this.cdr.detectChanges();
  }

  private pull(): Observable<CartPromoCode> {
    return this.apiService.get<CartPromoCode>('/promo-code').pipe(map(resp => resp.data));
  }

  usePromoCode() {
    this.pushPromoCode().pipe(
      map(response => this.handleResponse(response)),
      tap(_ => {
        this.eventCartService.emit({name: 'CartReload', data: true} as EventData);
      }),
      takeUntil(this.unsubscribe)
    ).subscribe();
  }

  private handleResponse(response: string) {
    this.promoCodeControl.setValue(response !== null ? response : '');
    this.cdr.detectChanges();
  }

  private pushPromoCode(): Observable<string> {
    const data = {
      promoCode: this.promoCodeControl.value
    };

    return this.apiService.post<any, string>('/promo-code/set', data).pipe(map(resp => resp.data));
  }

}
